<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange(page)" @row-save="handleSave"
        @row-update="handleUpdate" @selection-change="handleSelectionChange" @size-change="pageSizeChange"
        @current-change="pageChange">

        <template slot="menuLeft">
          <el-button type="success" icon="el-icon-download" size="mini" plain
            @click.stop="downloadExcelWorkOrder">下载Excel</el-button>
        </template>
        <template slot-scope="scope" slot="menuBtn">
          <el-button type="text" icon="el-icon-view" size="small" plain @click.stop="handleView(scope.row)">查看报单
          </el-button>
          <el-button type="text" icon="el-icon-document" size="small" plain @click.stop="openContract(scope.row)">查看协议</el-button>
          <el-button type="text" icon="el-icon-edit" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_EDIT_MERCHANTS" @click.stop="handleEdit(scope.row, scope.index)">编辑
          </el-button>
          <!-- 每个产品服务指派监理 -->
          <el-button type="text" icon="el-icon-success" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_EDIT_MERCHANTS" @click.stop="handleAssign(scope.row, scope.index)">指派监理
          </el-button>
          <el-button type="text" icon="el-icon-view" size="small" plain
            @click="handleViewServiceDiary(scope.row.id)">查看日志
          </el-button>
        </template>
        <template slot-scope="scope" slot="picUrl">
          <viewer :images="formmaterImage(scope.row.picUrl)">
            <img v-for="src in formmaterImage(scope.row.picUrl)" :src="src" :key="src" width="20">
          </viewer>
        </template>
      </avue-crud>
      <!-- 合同查看弹窗 -->
      <contract-view-dialog :visible.sync="contractDialogVisible" :declaration-id="currentDeclarationId" />
      <!-- 指派监理弹窗，每一个产品服务指派一个监理 -->
      <el-dialog title="指派监理" :visible.sync="dialogVisible1" width="50%" :close-on-click-modal="false">
        <div v-if="loadingEngineers">加载中...</div>
        <el-table v-else :data="selectedGoods" style="width: 100%" border>
          <el-table-column label="产品名称">
            <template slot-scope="scope">
              <el-select v-model="scope.row.goodsId" placeholder="请选择产品" disabled>
                <el-option v-for="goods in goodsList" :key="goods.id" :label="goods.name" :value="goods.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="指派监理" align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.engineeringSupervisor" placeholder="请选择监理" clearable>
                <el-option v-for="item in engineers" :key="item.userId" :label="item.username"
                  :value="item.userId"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <!-- 保存操作 -->
          <el-table-column align="center" label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="primary" icon="el-icon-success" @click="saveInfo(scope.row)">指 派</el-button>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancel1">关 闭</el-button>
        </span>
      </el-dialog>
      <view-service-diary :visibleRecord.sync="viewServiceDiaryVisible" :DiaryId="DiaryId" />
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { resolveUrlPath } from "@/util/util";
import { waterProjectTableOption } from "@/const/work/engineeringProject/merchantsOption";
import { findWaterProject, addWaterProject, editWaterProject, delWaterProject, downloadExcelCustomsDeclaration, getDownloadCode, getRootDepartmentId, findBindEngineer, addBindEngineer, findEngineer } from "@/api/work/engineeringProject/merchants"
import { findPureWaterGoodsByRootDepartId } from "@/api/salesCloud/goodsQr";
import ImageUpload from "@/components/imageUpload/ImageUpload";
import ViewServiceDiary from "./components/viewServiceDiary/index.vue";
import ContractViewDialog from "./components/contract-view-dialog.vue";
export default {
  name: "waterProject",
  components: {
    ImageUpload,
    ViewServiceDiary,
    ContractViewDialog,
  },
  data() {
    return {
      tableOption: waterProjectTableOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      users: [],
      rules1: {
        engineeringSupervisor: [
          { required: true, message: "请选择监理", trigger: "change" },
        ],
      },
      DiaryId: "",
      viewServiceDiaryVisible: false,
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 50 //每页显示多少条
      },
      goodsList: [],
      selectedGoods: [],
      dialogVisible: false,
      dialogVisible1: false,
      loadingEngineers: false,  // 添加加载状态标志
      WarehouseList: [],
      downloadData: {},
      rootDepartmentId: "",
      superiors: [],
      superior: {},
      picUrl: "",
      fileList: [],
      engineers: "",
      // 合同查看
      contractDialogVisible: false,
      currentDeclarationId: "",
    };
  },
  created() {
    this.getEngineers(); // 获取所有监理
    this.getGoodsByRootDepartId();
    this.handleList();
  },
  watch: {},
  mounted() { },
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    openContract(row) {
      this.currentDeclarationId = row.id || row.declarationId;
      this.contractDialogVisible = true;
    },
    // 获取所有监理
    async getEngineers() {
      this.loadingEngineers = true;  // 启动加载状态
      const params = { type: "JOINS_ENGINEER", manager: "SUPERVISOR",page:1,size:100 }; // 这里可以根据需要调整接口参数
      try {
        const res = await findBindEngineer(params);
        if (res.code === "200") {
          this.engineers = JSON.parse(res.data).rows || [];
          // 加载完成后，关闭加载状态
          this.loadingEngineers = false;
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        console.error("获取监理失败:", error);
        this.$message.error("获取监理失败");
      } finally {
        this.loadingEngineers = false;  // 请求完成后关闭加载状态
      }
    },

    // 处理指派监理的逻辑
    async handleAssign(row) {
      this.dialogVisible1 = true;
      this.selectedGoods = row.list.map(item => ({
        goodsId: item.goodsId,
        serviceOrderId: item.serviceOrderId,
        declarationId: item.declarationId,
        engineeringSupervisor: item.engineeringSupervisor || null,
      }));

      /* // 启动加载状态，等待监理数据加载完成
      this.loadingEngineers = true; */
      await this.getEngineerByServiceOrderId(row.id);  // 获取当前工单的各个产品监理
    },

    saveInfo(row) {
      if (!row.engineeringSupervisor) {
        this.$message.error("请选择监理");
        return;
      }
      this.$confirm("是否确认指派监理?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        addBindEngineer(row).then((res) => {
          if (res.code == "200") {
            this.$message({
              type: "success",
              message: "指派成功!"
            });
            this.users = [];
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error",
            });
          }
        });
      });
    },
    cancel1() {
      this.dialogVisible1 = false;
    },

    handleSupervisor(val) {
      console.log('this.users:::0 ', this.users);
      if (val == '') {
        this.users = [];
      } else {
        this.users = this.users.filter(item => item.userId == val);
        console.log('this.users::: ', this.users);
      }
    },
    handleRemoteSupervisor(query) {
      // eslint-disable-next-line no-control-regex
      if (/[^\x00-\xff]/.test(query)) {
        // console.log('query:1: ', query);
        this.users = [];
        setTimeout(() => {
          let params = {
            type: "JOINS_ENGINEER",
            manager: "SUPERVISOR",
            mobile: query,
          };
          findBindEngineer(params).then((res) => {
            if (res.code == "200") {
              let data = JSON.parse(res.data).rows;
              console.log('data::: ', data);
              this.users = data
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error",
              });
            }
          });
        }, 200);
      } else if (/^\d{11}$/.test(query)) {
        this.users = [];
        setTimeout(() => {
          let params = {
            type: "JOINS_ENGINEER",
            manager: "SUPERVISOR",
            mobile: query,
          };
          findBindEngineer(params).then((res) => {
            if (res.code == "200") {
              let data = JSON.parse(res.data).rows;
              console.log('data:::1 ', data);
              this.users = data
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error",
              });
            }
          });
        }, 200);
      }
    },
    /**
     * @title 获取当前工单的各个产品监理
     * @param id 工单id
     * @description 根据工单id获取当前工单的各个产品监理
     */
    async getEngineerByServiceOrderId(id) {
      const params = { declarationId: id, type: "ENGINEERING" };
      try {
        const res = await findEngineer(params);  // 假设 findEngineer 已经返回一个 Promise
        if (res.code === "200") {
          let data = JSON.parse(res.data).rows;
          if (data) {
            this.selectedGoods = this.selectedGoods.map(item => {
              let engineer = data.find(d => d.goodsId === item.goodsId);
              if (engineer) {
                item.engineeringSupervisor = engineer.engineeringSupervisor;
                this.users.push({
                  userId: engineer.engineeringSupervisor,
                  username: engineer.engineeringSupervisorName,
                });
              }
              return item;
            });
          } else {
            this.selectedGoods = [];
          }
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        console.error('获取监理数据失败:', error);
        this.$message.error('获取监理数据失败');
      }
    },
    /**
     * 
     * @param selectedGoods 选中的商品
     * @description 根据商品id获取商品名称
     */
    formatGoodsByRootDepartId(selectedGoods) {
      if (this.goodsList) {
        this.selectedGoods = selectedGoods.map(item => ({
          goodsId: item.goodsId,
          serviceOrderId: item.serviceOrderId,
          declarationId: item.declarationId,
          name: this.goodsList.find(g => g.id === item.goodsId) ? this.goodsList.find(g => g.id === item.goodsId).name : ""
        }));
      } else {
        this.goodsList = [];
      }
    },
    handleViewServiceDiary(id) {
      this.DiaryId = id;
      this.viewServiceDiaryVisible = true;
    },

    // 获取商品列表
    getGoodsByRootDepartId() {
      const type = 'ENGINEERING'
      findPureWaterGoodsByRootDepartId(type).then(res => {
        if (res.code === "200") {
          let data = JSON.parse(res.data);
          if (data) {
            this.goodsList = data;
          } else {
            this.goodsList = [];
          }
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    // 生成商家码并显示弹窗
    downloadCode(type) {
      this.$confirm("是否确认生成通用码?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const data = {
          scene: this.rootDepartmentId,
          page: type.type == 1 ? "pages/waterProject/install/install" : "pages/waterProject/customer/customer",
          width: "340",
          clientType: type.type == 1 ? "JOINS_MERCHANT" : "JOINS_USER"
        };
        getDownloadCode(data).then((response) => {
          // 提取文件名
          const filename = response.headers["content-disposition"].match(
            /filename=(.*)/
          )[1];
          // 将二进制流转为blob
          const blob = new Blob([response.data], {
            type: "application/octet-stream",
          });
          if (typeof window.navigator.msSaveBlob !== "undefined") {
            // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
            window.navigator.msSaveBlob(blob, decodeURI(filename));
          } else {
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob);
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement("a");
            tempLink.style.display = "none";
            tempLink.href = blobURL;
            tempLink.setAttribute("download", decodeURI(filename));
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === "undefined") {
              tempLink.setAttribute("target", "_blank");
            }
            // 挂载a标签
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL);
            this.handleList();
          }
        });
      })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消生成通用码"
          });
        });
    },
    formmaterImage(row) {
      let str = new Array();
      JSON.stringify(row);
      if (row != null) {
        let picArray = row.split(",");
        for (let i = 0; i < picArray.length; i++) {
          str.push(picArray[i]);
        }
      }
      return str;
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage,
        params.size = pageSize
      findWaterProject(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      })
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm
      params.page = page
      params.size = this.page.pageSize
      findWaterProject(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      })
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage
      params.size = this.page.pageSize
      this.downloadData = params;
      findWaterProject(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      })
    },
    downloadExcelWorkOrder() {
      let params = this.downloadData;
      params.type = "ENGINEERING";
      downloadExcelCustomsDeclaration(params).then((response) => {
        // 提取文件名
        const filename = response.headers["content-disposition"].match(
          /filename=(.*)/
        )[1];
        // 将二进制流转为blob
        const blob = new Blob([response.data], {
          type: "application/octet-stream",
        });
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
          window.navigator.msSaveBlob(blob, decodeURI(filename));
        } else {
          // 创建新的URL并指向File对象或者Blob对象的地址
          const blobURL = window.URL.createObjectURL(blob);
          // 创建a标签，用于跳转至下载链接
          const tempLink = document.createElement("a");
          tempLink.style.display = "none";
          tempLink.href = blobURL;
          tempLink.setAttribute("download", decodeURI(filename));
          // 兼容：某些浏览器不支持HTML5的download属性
          if (typeof tempLink.download === "undefined") {
            tempLink.setAttribute("target", "_blank");
          }
          // 挂载a标签
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          // 释放blob URL地址
          window.URL.revokeObjectURL(blobURL);
          this.searchChange(params);
        }
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm
      params.page = page.currentPage
      params.size = page.pageSize
      findWaterProject(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      })
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // 清空表单
      this.cleanForm();
      this.$refs.crud.rowAdd();
    },
    handleView(row) {
      // 查看
      let obj = {
        label: "查看商户报单",
        value: "/work/engineeringProject/merchants/view",
        query: { id: row.id },
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query,
      });
    },
    handleEdit(row) {
      // 去编辑
      let obj = {
        label: "编辑商户报单",
        value: "/work/engineeringProject/merchants/edit",
        query: { id: row.id },
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query,
      });
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize
      }
      findWaterProject(parmas).then((res) => {
        let data = JSON.parse(res.data);
        console.log('data::: ', data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        getRootDepartmentId().then(res => {
          let data = res.data;
          this.rootDepartmentId = data;
        });
        this.tableLoading = false;
      })
    },
    /**
     * @title cleanForm
     */
    cleanForm() {
      this.superior = {};
      this.superior.id = null;
      this.picUrl = "";
      this.fileList = [];
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      row.superiorId = this.superior.id;
      row.picUrl = this.picUrl;
      addWaterProject(row).then(response => {
        if (response.code == '200') {
          this.$message({
            showClose: true,
            message: "添加成功",
            type: "success"
          });
          this.cleanForm();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error"
          })
        }

      }).catch(error => {
        this.loading = false
        this.$message({
          showClose: true,
          message: error,
          type: "error"
        })
      })
      done();
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange(val) {
      this.tableRow = val;
      /* this.$notify({
          showClose: true,
          message: JSON.stringify(val),
          type: 'success',
      }); */
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel() {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error"
        })
        return
      }

      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id)
          }

          delWaterProject(ids).then(response => {
            if (response.code == '200') {
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success"
              });
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error"
              })
            }

          }).catch(error => {
            this.loading = false
            this.$message({
              showClose: true,
              message: error,
              type: "error"
            })
          })
        })
        .catch(() => { });

    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      row.superiorId = this.superior.id
      row.picUrl = this.picUrl;
      editWaterProject(row).then(response => {
        if (response.code == '200') {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success"
          });
          this.cleanForm();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error"
          })
        }

      }).catch(error => {
        this.loading = false
        this.$message({
          showClose: true,
          message: error,
          type: "error"
        })
      })
      done();
    },
  }
};
</script>

<style lang="scss" scoped>
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

::v-deep .el-table--medium td {
  padding: 0 !important;
}

::v-deep .el-table {
  font-size: 12px !important;
}

::v-deep .el-form-item {
  margin-bottom: 0px !important;
}

::v-deep .el-table--medium th {
  padding: 0px !important;
}

::v-deep .el-table td .el-table th {
  padding: 0px !important;
}
</style>